import { nonNullable } from '../object';
export const compactNullish = (array) => array.filter(nonNullable);
